<template>
  <div>
    <qx-card title="管理费申请" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      >
        <span slot-scope="prop" slot="payAmt">
          {{prop.data.payAmt}}
          <span class="error">
            {{prop.data.budgetBalance}}
          </span>
        </span>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="22000023"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  manageDetail, // 获取详情
  manageGetBudgetBalance, // 预算金额
} from 'api/cost';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: null,
    },
  },
  data () {
    return {
      loading: false,
      baseTitle: [
        {
          prop: 'applyUserName',
          label: '申请人',
        },
        {
          prop: 'applyTime',
          label: '申请时间',
        },
        {
          prop: 'payTypeName',
          label: '付款类型',
        },
        {
          prop: 'orgName',
          label: '费用归属',
        },
        {
          prop: 'payAmt',
          label: '申请金额',
          slot: true,
        },
        {
          prop: 'isNeedBillName',
          label: '是否开票',
        },
        {
          prop: 'principal',
          label: '本金',
        },
        {
          prop: 'interest',
          label: '利息',
        },
        {
          prop: 'etcTrafficFee',
          label: 'ETC通行费',
        },
        {
          prop: 'etcServiceFee',
          label: '服务费',
        },
        {
          prop: 'etcLateFee',
          label: '滞纳金',
        },
        {
          prop: 'payRemark',
          label: '申请原因',
        },
        {
          prop: 'feeAscriptionDate',
          label: '费用归属日期',
        },
        {
          prop: 'fileUrl',
          label: '附件',
          type: 'img',
        },
      ],
      detailData: {
        base: {
          label: '申请信息',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        settlement: {
          label: '收款信息',
          tableData: {
            title: [
              {
                prop: 'receName',
                label: '收款方名称',
              },
              {
                prop: 'receUserName',
                label: '收款账户名',
              },
              {
                prop: 'receBankName',
                label: '收款银行',
              },
              {
                prop: 'receBankNo',
                label: '收款账号',
              },
              {
                prop: 'userTypeName',
                label: '收款人类型',
              },
              // {
              //   prop: 'balanceTypeName',
              //   label: '结算方式',
              // },
              // {
              //   prop: 'expireDate',
              //   label: '付款日期',
              // },
              // {
              //   prop: 'deductAmount',
              //   label: '结算方式',
              // },
              {
                prop: 'deductAmount',
                label: '抵扣借支',
              },
              {
                prop: 'shouldPayAmount',
                label: '应付金额',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/cost/manage/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await manageDetail({
        payId: this.id || this.$route.query.id,
        isEdit: 2,
      });
      const applyTime = new Date(detailRes.applyTime);
      const manageGetBudgetBalanceRes = await manageGetBudgetBalance({
        costType: detailRes.payType,
        orgId: detailRes.orgId,
        month: applyTime.getFullYear() + '' + (applyTime.getMonth() + 1),
      });
      detailRes.budgetBalance = `（预算金额：${manageGetBudgetBalanceRes.sumBudget || '无预算'}）`;
      this.loading = false;
      if (!detailRes.failed) {
        const etc = ['etcTrafficFee', 'etcServiceFee', 'etcLateFee'];
        const borrow = ['principal', 'interest'];
        const list = this.detailData.base.tableData.title = JSON.parse(JSON.stringify(this.baseTitle));
        for (let i = 0; i < list.length; i++) {
          if (
            (detailRes.payType === 4300 && borrow.indexOf(list[i].prop) !== -1) ||
            ((detailRes.payType === 4302 || detailRes.payType === 4303) && etc.indexOf(list[i].prop) !== -1) || // 贷款、保理
            (detailRes.payType !== 4300 && detailRes.payType !== 4302 && borrow.indexOf(list[i].prop) !== -1 || etc.indexOf(list[i].prop) !== -1)
          ) {
            list[i] = null;
          }
        }
        this.detailData.base.tableData.title = list.filter((item) => Boolean(item));
        this.detailData.base.tableData.data = detailRes;
        this.detailData.settlement.tableData.data = detailRes;
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
